export default "__VITE_ASSET__C4roSTUX__"